// src/App.js
import React from "react";
import Home from "./pages/Home"; // adjust path if Home.js is in a different folder

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
